import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          <code>Btw, I own this domain name.</code>
        </p>
        <img src='https://res.cloudinary.com/cjmaybe/image/upload/v1783609808/meme_io8sin.png' width="300" height='default' alt='meme' className='meme'/>
        <br></br>
        <a 
          className="App-link"
          href="https://github.com/cjmaybe"
          target="_blank"
          rel="noopener noreferrer"
        >
          View My GitHub Profile
        </a>
      </header>
    </div>
  );
}

export default App;
